export default function getDefaultPosition() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  // Spacing by default between two items
  var spanner = 2048; // We add a randomized number so collisions can be recovered

  var random = Math.floor(Math.random() * 48);
  return position + spanner + random;
}